import { Component, inject } from "@angular/core";
import { SideMenuItem, SubMenu, SubMenuItem } from "@zeraki/zeraki-ui";
import { UserPermissionsService } from "src/app/core/services/user-permissions.service";
import { UserRoleService } from "src/app/core/services/user-role.service";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-side-menu-internal-views",
	templateUrl: "./side-menu-internal-views.component.html",
	imports: [SideMenuItem, SubMenu, SubMenuItem],
})
export class SideMenuInternalViewsComponent {
	isTest = !environment.production;

	public userRole = inject(UserRoleService);
	public userPermissions = inject(UserPermissionsService);
}
